import Box from '@amzn/meridian/box';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Profile } from '../../Types';
import Text from '@amzn/meridian/text';
import TrainingStats from './TrainingStats';
import ProfileContainer from '../Dashboard/DashboardContainers/ProfileContainer';
import { TRAILING_DAYS } from '../Dashboard/DashboardComponents/LighthouseMetrics/types';
import { weeksList } from '../../Util/Week';
import TrainingList from './TrainingList';

interface TrainingTmHomeProps {
  profile: Profile;
  profileState: string;
}

const TrainingTmHome: React.FC<TrainingTmHomeProps> = ({
  profile,
  profileState,
}) => {
  const weekOptions = [TRAILING_DAYS, ...weeksList()];
  const [weekValue, setWeekValue] = useState(weekOptions[0]);

  const setWeek = (e: React.FormEvent<HTMLSelectElement>): void => {
    setWeekValue(e.toString());
  };
  return (
    <Box height='100%'>
      <ProfileContainer
        state={profileState}
        profile={profile}
        selectedWeek={weekValue}
        setWeek={setWeek}
        isBig={true}
      />
      <Box spacingInset='none none 450'>
        <Text type='h500'>
          <FormattedMessage
            id='cs_perfportal_training_page_assignments_title'
            defaultMessage='Team Training Assignments'
          />
        </Text>
      </Box>

      <Box spacingInset='none none 450'>
        <TrainingStats profile={profile} />
      </Box>
      <TrainingList profile={profile} />
    </Box>
  );
};

export default TrainingTmHome;
